import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { RegistrationProvider } from "./components/funnel";
import OptInPage from "./pages/OptInPage";
import BridgePage from "./pages/BridgePage";
import RegisteredPage from "./pages/RegisteredPage";
import ReplayPage from "./pages/ReplayPage";
import ApplyPage from "./pages/ApplyPage";
import LegalPage from "./pages/LegalPage";
import ContactPage from "./pages/ContactPage";
import PlaceholderPage from "./pages/PlaceholderPage";
import { PRIVACY, TERMS, REFUND } from "./data/legal";

const LEGAL = [["/privacy", PRIVACY], ["/terms", TERMS], ["/refund", REFUND]];

function App() {
  return (
    <BrowserRouter>
      <RegistrationProvider>
        <Routes>
          <Route path="/" element={<OptInPage />} />
          <Route path="/bridge" element={<BridgePage />} />
          <Route path="/registered" element={<RegisteredPage />} />
          <Route path="/replay" element={<ReplayPage />} />
          <Route path="/apply" element={<ApplyPage />} />
          {LEGAL.map(([path, page]) => (
            <Route key={path} path={path} element={<LegalPage page={page} />} />
          ))}
          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<PlaceholderPage kicker="404" title="Page not found" slug="not-found" />} />
        </Routes>
      </RegistrationProvider>
    </BrowserRouter>
  );
}

export default App;
